import { Button, Stack, useTheme } from "@mui/material";
import { AlertCircle } from "lucide-react";
import type { FC } from "react";
import { Callout } from "web_myplann/Shared/Components/Callout";

type Props = {
	title: string;
	description: string;
	retryLabel: string;
	isRetrying: boolean;
	onRetry: () => void;
};

export const LoadErrorWithRetry: FC<Props> = ({
	title,
	description,
	retryLabel,
	isRetrying,
	onRetry,
}) => {
	const { spacingTokens } = useTheme();

	return (
		<Stack px={spacingTokens.lg} pt={spacingTokens.lg} gap={spacingTokens.lg}>
			<Callout
				color="red"
				icon={AlertCircle}
				title={title}
				description={description}
			/>
			<Button variant="secondary" loading={isRetrying} onClick={onRetry}>
				{retryLabel}
			</Button>
		</Stack>
	);
};
